virtual task monitor_data({{ sequenceItemHandle.type }} {{ sequenceItemHandle.identifier }});
  {{ sequenceItemHandle.identifier }}.{{ sequenceItem.phaseEnumVariable.identifier }} = {{ sequenceItem.phaseEnumVariable.klass.request.name }};
  {{ sequenceItemHandle.identifier }}.data = new[{{ package.beatsInBurstMaxParameter.name }}];

  // pending_data_item = {{ sequenceItemHandle.identifier }};
  wait ({{ sequenceItemHandle.identifier }}.{{ sequenceItemHandle.klass.beatIndexVariable.identifier }} > 0);
endtask
